// Shared constants for capturing the first-touch Google Ads click id
// (gclid, or gbraid/wbraid on iOS) and carrying it through to WhatsApp
// conversations for ad attribution.

export const CLICK_REF_COOKIE = 'df_click_ref';
export const CLICK_REF_MAX_AGE_DAYS = 90;
// Holds the raw click id until the visitor answers the consent banner.
export const CLICK_REF_PENDING_COOKIE = 'df_click_pending';
export const CONSENT_COOKIE = 'cookie_consent';
export const CLICK_REF_PARAMS = ['gclid', 'gbraid', 'wbraid'] as const;

// Dispatched on `window` once the pending click id is resolved (promoted or
// discarded) after the visitor answers the consent banner, so components
// that already rendered a link/cookie value can refresh it.
export const CLICK_REF_RESOLVED_EVENT = 'df-click-ref-resolved';
